import React, { useContext } from "react";
import moment from "moment";
import { getFileExtension, getFileFormat } from "../../../utils/fileUtils";

// Styles
import "../../../assets/css/MultimediaChat.css";

// Components
import Spinner from "../../../components/Spinners/Spinner";

// Utils
import { useGetDta } from "../../../hooks/useGetDta";
import { ChatContext } from "../../../context/chat/ChatContext";

const baseURL = process.env.REACT_APP_API;

/**
 * Pestaña de archivos de chat
 *
 * @returns {JSX.Element} Componente de react
 */
const FilesTab = () => {
  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;
  // Obtener archivos del chat
  const { loading, data } = useGetDta(
    `sms/files`,
    {
      id: activeChat.id_user || activeChat.id,
    },
    "POST"
  );

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner />
      </div>
    );

  return (
    <>
      <div className="d-flex flex-column gap-1">
        {data.length === 0 ? (
          <div className="text-center">
            <p className="text-secondary">No hay archivos</p>
          </div>
        ) : (
          data.map((file, index) => (
            <div
              className="file-item d-flex align-items-center border border-light gap-1 rounded"
              key={index}
              onClick={() => {
                window.open(`${baseURL}/${file.object}`);
              }}
            >
              <i
                className={`file-icon ${getFileFormat(
                  file.object
                )} font-20 rounded p-2`}
              />

              <div>
                <span className="d-block font-15 fw-bold">
                  {`${moment(file.date).format("DDMMYYYY")}.${getFileExtension(
                    file.object
                  )}`}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default FilesTab;
